import { Container, Grid } from "@mui/material";
import React from "react";
import Logo from "../../../../styles/img/df-logo.png";
import { useNavigate } from "react-router-dom";
import set from "../../../../styles/img/onboard/all-set.png"
import { UiButton } from "../../component/common/UiButton";

export const UiAccountReady = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-pw-tab">
            <Grid container className="df-align-center">
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }} className="df-pr-2">
                <img
                  src={set}
                  className="df-verify-progress-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center"
              >
                <div className="df-onboard-radio df-onboard-nic-wr df-verify-progress">
                  <h4>You are all set!</h4>
                  <p>Your online banking account is now ready to be used!</p>

                  <div className="d-block df-verify-progress__acc-btn">
                    <UiButton
                      className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                      name="Login to your LOLC Realtime Account"
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
